import React from 'react';

export const pipe = (...fns) => x => fns.reduce((y, f) => f(y), x);

export const compose = (...fns) => x => fns.reduceRight((y, f) => f(y), x);

export const trace = label => (value) => {
  // eslint-disable-next-line no-console
  console.log(label, value);
  return value;
};
export const flip = fn => b => a => fn(a)(b); // flips the argument order for an arity-2 fn

export const passthrough = x => x;

// prepares a functional component for composition
export const inSeries = (CurrentComponent) => (PreviousComponent) => (props) => (
  <>
    {PreviousComponent && <PreviousComponent {...props} />}
    <CurrentComponent {...props} />
  </>
);
